import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class PercentageofbreakListService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	searchPercent(token, porcentagem, status, orderby, sort, page) {
		

		
		
		
		
		
		

		var filter = "&$filter=";

		var statusFilter = "";
		if (status != "") {
			statusFilter = "Ativo eq " + status;
		}

		var porcentagemFilter = "";
		if (porcentagem != "") {
			porcentagemFilter = "Porcentagem eq " + porcentagem;
		}

		var applyFilter = "";

		if (statusFilter) {
			applyFilter = statusFilter;
		}

		if (porcentagemFilter) {
			applyFilter = porcentagemFilter;
		}

		if (statusFilter && porcentagemFilter) {
			applyFilter = statusFilter + " and " + porcentagemFilter;
		} else {
			if (statusFilter) {
				applyFilter = statusFilter;
			}
			if (porcentagemFilter) {
				applyFilter = porcentagemFilter;
			}
		}

		if (statusFilter || porcentagemFilter) {
			applyFilter = "&$filter=" + applyFilter;
		}

		page = page * globalConst.paginationSkip;

		return this.http
		.get(this.apiUrl + "percentageofbreak/v1/getpercentageofbreak?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + applyFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/percentageofbreak/service/percentageofbreak-list/percentageofbreak-list.service.ts